export const EMBED_PANEL_COPY = {
  access: "Access",
  look: "Look",
  actions: "What viewers can do",
  data: "Data",
  enable: "Anyone who can see the site",
  enableHint: "Turn off to stop the embed working.",
  header: "Header",
  nav: "Navigation and toolbar",
  chrome: "Frame and chrome",
  chromeHint: "Off shows the content only: no header, navigation, footer or frame.",
  poweredBy: "Powered by MagicBI",
  logo: "Logo",
  logoMagicbi: "MagicBI",
  logoNone: "None",
  theme: "Theme",
  themeLight: "Light",
  themeDark: "Dark",
  themeAuto: "Auto",
  fullscreen: "Fullscreen button",
  lifetime: "Embed lifetime",
  codeLocked: "Turn on \u2018Anyone who can see the site\u2019 to get the embed code",
  noLink: "No link yet",
  preview: "Live preview",
  previewTitle: "Embed preview",
  previewEmpty: "Preparing the preview…",
  code: "Embed code",
  copy: "Copy",
  copied: "Copied",
  loadError: "Unable to load embed settings.",
  saveError: "Unable to save embed settings.",
  comingSoon: {
    workspaceAccess: "Workspace access level",
    allowedSites: "Allowed sites",
    workspaceLogo: "Workspace logo",
    presetFilters: "Pre-set filters",
    readOnlyFilters: "Read-only filter bar",
    download: "Download and export",
    explanations: "Explanations",
    askAi: "Ask AI",
    viewData: "View data and SQL",
    freshness: "Freshness snapshot",
    updatedStamp: "Updated stamp",
    autoFit: "Auto-fit height",
  },
} as const;
